import { Container } from '@pixi/react'
import {
  AutoButtonV2, FeatureToggleV2Type, MenuBarFeatureToggleV2, soundManager, SoundType, SpinButton, StakeControlPortrait, TurboButton,
  useAutoPlayStore, useFeatureToggleV2, useIsSpinning,
} from '@slot-nx/core'
import { gameConfig } from '../config'
import { useMemo } from 'react'
import { onSpinningCallback, spinEvent } from '../domain/spin/SpinUtil'
import { threecomboolympusMachine } from '../domain/machine/threecomboolympusMachine'
import { GameStatus, useGameStore } from '../domain/game/store/GameStore'
import { useSelector } from '@xstate/react'
import { GodziSpinButton } from './godziDrop/GodziSpinButton'
interface ControlGroupProps {
  x: number
  y: number
}

const width = gameConfig.resolution.width - 192
const height = 216
const startX = 96

export const ControlGroup = (props: ControlGroupProps) => {
  const isSpinning = useIsSpinning()
  const currentState = useSelector(threecomboolympusMachine, state => state)
  const isInitialState = currentState.matches('init game')
  const gameStatus = useGameStore(x => x.gameStatus)
  const { isPlaying } = useAutoPlayStore()
  const enableAutoPlay = useFeatureToggleV2(FeatureToggleV2Type.enableAutoPlay)
  const enableTurbo = useFeatureToggleV2(FeatureToggleV2Type.enableTurbo)
  const spinBtnEnabled = useMemo(() => {
    return !(!isSpinning && !(isInitialState))
  }, [isInitialState, isSpinning])
  const commonButtonEnabled = useMemo(() => {
    return isInitialState && gameStatus !== GameStatus.Voucher && gameStatus !== GameStatus.Godzi && !isPlaying
  }, [gameStatus, isInitialState, isPlaying])

  return (
    <Container name="ControlGroup" x={props.x}>
      <SpinButton
        x={(width - 216) / 2 + startX}
        y={props.y}
        enabled={spinBtnEnabled}
        width={216}
        height={216}
        isSpinning={isSpinning}
        durationInSeconds={isSpinning ? 0.7 : 1.5}
        onSpin={() => {
          soundManager.play(SoundType.buttonConfirm)
          spinEvent()
        }}
        onSpinning={() => {
          onSpinningCallback()
        }}
      />
      <StakeControlPortrait
        x={(width - 452) / 2 + startX}
        y={props.y + 69}
        enabled={commonButtonEnabled}
      />
      {enableTurbo && <TurboButton x={140} y={props.y + 47} width={120} height={120} />}
      {enableAutoPlay && (
        <AutoButtonV2
          enabled={isInitialState}
          x={width - 72}
          y={props.y + (height - 120) / 2}
          width={120}
        />
      )}
      <GodziSpinButton />
      <MenuBarFeatureToggleV2 x={0} y={props.y + 30} isEnabled={commonButtonEnabled} />
    </Container>
  )
}
